import { render, staticRenderFns } from "./viewFixedPurchasesReturn.vue?vue&type=template&id=e61c1bf0&scoped=true&"
import script from "./viewFixedPurchasesReturn.vue?vue&type=script&lang=js&"
export * from "./viewFixedPurchasesReturn.vue?vue&type=script&lang=js&"
import style0 from "./viewFixedPurchasesReturn.vue?vue&type=style&index=0&id=e61c1bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61c1bf0",
  null
  
)

export default component.exports